type Props = {
  name: string;
  size: string;
  className?: string;
  sizeH?: string;
};

const ICON_PATH: {
  [key: string]: string;
} = {
  checked: '/assets/images/icons/common-ico-20-ico-20-select.svg',
  delete: '/assets/images/icons/common-ico-16-ico-16-delete.svg',
  menu_b: '/assets/images/icons/common-ico-32-ico-32-menu-b.svg',
  ticket_b: '/assets/images/icons/ico-32-ticket-b.svg',
  menu_w: '/assets/images/icons/common-ico-32-ico-32-menu-w.svg',
  ticket_w: '/assets/images/icons/ico-32-ticket-w.svg',
  checkbox_nor: '/assets/images/icons/common-ico-20-ico-20-checkbox-nor.svg',
  checkbox_active: '/assets/images/icons/common-ico-20-ico-20-checkbox-active.svg',
  down: '/assets/images/icons/common-ico-20-ico-20-down.svg',
  country: '/assets/images/icons/common-ico-20-ico-20-country.svg',
  back: '/assets/images/icons/common-ico-32-ico-32-back.svg',
  close: '/assets/images/icons/common-ico-32-ico-32-close.svg',
  setting: '/assets/images/icons/common-ico-20-ico-20-setting.svg',
  tv: '/assets/images/icons/common-ico-48-ico-48-tv.svg',
  bixby: '/assets/images/icons/common-ico-48-ico-48-bixby.svg',
  logo: '/assets/images/common/img-kyoung-logo-light@3x.png',
  logo_s: '/assets/images/common/img-48-kyoung-logo-light@3x.png',
  logo_s_b: '/assets/images/common/img-48-kyoung-logo-dark@3x.png',
  logo_bixby: '/assets/images/common/common-img-img-logo-bixby.svg',
  logo_karaoke: '/assets/images/common/common-img-img-logo-karaoke@2x.png',
  account: '/assets/images/icons/common-ico-32-ico-32-account.svg',
  coupon: '/assets/images/icons/common-ico-32-ico-32-coupon.svg',
  customer: '/assets/images/icons/common-ico-32-ico-32-customer.svg',
  faq: '/assets/images/icons/common-ico-32-ico-32-faq.svg',
  mobile: '/assets/images/icons/common-ico-20-ico-20-mobile.svg',
  email: '/assets/images/icons/common-ico-20-ico-20-email.svg',
  'arrow-b': '/assets/images/icons/common-ico-12-ico-12-arrow-b.svg',
  arrow_w: '/assets/images/icons/common-ico-12-ico-12-arrow-w.svg',
  error: '/assets/images/icons/common-ico-52-ico-52-error.svg',
  play: '/assets/images/icons/common-ico-20-ico-20-play.svg',
  stop: '/assets/images/icons/common-ico-20-ico-20-stop.svg',
  'buy-k': '/assets/images/icons/common-ico-32-ico-32-buy-k.svg',
  event: '/assets/images/icons/common-ico-32-ico-32-event.svg',
  'tv-w': '/assets/images/icons/common-ico-40-ico-40-tv-w.svg',
  top: '/assets/images/icons/common-ico-20-ico-20-top.svg',
  invisible: '/assets/images/icons/common-ico-20-ico-20-invisible.svg',
  visible: '/assets/images/icons/common-ico-20-ico-20-visible.svg',
  notice: '/assets/images/icons/common-ico-32-ico-32-notice.svg',
};

export default function Icon({ name, size, className, sizeH }: Props): JSX.Element {
  return (
    <div className={['icon'].join(' ') + (className ? ' ' + className : '')}>
      <span
        className={['block', 'bg-no-repeat', 'bg-100'].join(' ')}
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + ICON_PATH[name]})`,
          width: size + 'px',
          height: (sizeH ? sizeH : size) + 'px',
        }}
      ></span>
    </div>
  );
}
